import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  pt: { translation: pt },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "de",
    supportedLngs: ["en", "de", "fr", "pt"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hx_lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> in sync with the active locale (a11y + SEO)
if (typeof document !== "undefined") {
  const syncLang = (lng) => {
    document.documentElement.lang = (lng || "de").split("-")[0];
  };
  syncLang(i18n.language);
  i18n.on("languageChanged", syncLang);
}

export const LANGUAGES = [
  { code: "de", name: "Deutsch", short: "DE", flag: "🇩🇪" },
  { code: "en", name: "English", short: "EN", flag: "🇬🇧" },
  { code: "fr", name: "Français", short: "FR", flag: "🇫🇷" },
  { code: "pt", name: "Português", short: "PT", flag: "🇵🇹" },
];

export default i18n;
